<template>
   <div>
      <div class="mt-4 pt-4">
         <h1>Scanner</h1>
         <div class="mt-4">
            <div class="row">
               <div class="col-12">
                  <div class="card">
                     <div class="card-header mb-4">
                        <div class="position-relative m-4">
                           <div class="progress" style="height: 1px;">
                              <div class="progress-bar" role="progressbar" style="width: 50%;" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                           </div>
                           <button type="button" class="position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">1</button>
                           <button type="button" class="position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">2</button>
                           <button type="button" class="position-absolute top-0 start-100 translate-middle btn btn-sm btn-secondary rounded-pill" style="width: 2rem; height:2rem;">3</button>
                        </div>
                     </div>
                     <div class="card-body">

                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#pages" type="button" role="tab" aria-controls="home" aria-selected="true">Pages</button>
                          </li>
                          <li class="nav-item" role="presentation">
                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#auth" type="button" role="tab" aria-controls="profile" aria-selected="false">Authentication</button>
                          </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                          <div class="tab-pane fade show active" id="pages" role="tabpanel">
                            <div class="row mt-4">
                               <div class="col-6">
                                     <h4 class="card-title">Pages</h4>
                                 </div>
                                 <div class="col-6 text-end">
                                     <button class="btn btn-primary btn-sm me-2" v-on:click="autoScan()">Add Page Automatically</button>

                                     <button class="btn btn-success btn-sm me-2" data-bs-toggle="modal" data-bs-target="#importSwagger">Import via SWAGGER</button>

                                     <button class="btn-sm  btn btn-warning" data-bs-toggle="modal" data-bs-target="#AddPageManually" v-on:click="refresh = Math.random(); page_id = 0">Add Page Manually</button>
                                 </div>
                                <div class="col-md-12">
                                        <div class="card-body table-full-width table-responsive">
                                            <table class="table table-hover table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>METHOD</th>
                                                        <th>URL</th>
                                                        <th>Date Created</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="p in pages" v-bind:key="p.ID">
                                                        <td>{{ p.method }}</td>
                                                        <td width="80%">{{ p.page }}</td>
                                                        <td>{{ p.CreatedAt | moment("ll") }}</td>
                                                        <td>
                                                          <a href="javascript:void(0)" class="text-warning me-2"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#AddPageManually"
                                                            v-on:click="EditPage(p.ID)"
                                                          >
                                                                <i class="far fa-edit"></i>
                                                            </a>
                                                            <a href="javascript:void(0)" class="text-danger" title="Delete" v-on:click="deletePage(p.ID)">
                                                                <i class="fa fa-trash"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                </div>
                            </div>
                          </div>
                          <div class="tab-pane fade" id="auth" role="tabpanel">
                            <Authentication />
                          </div>
                        </div>



                     </div>
                     <div class="card-footer text-end">
                        <router-link :to="'/' + org_id + '/scan/' + project_id" class="btn btn-lg btn-secondary text-light ps-4 pe-4 me-4">Back <i class="fas fa-angle-left"></i></router-link>
                        <router-link :to="'/' + org_id + '/scan/' + project_id + '/step/3'" class="btn btn-lg btn-info text-light ps-4 pe-4">NEXT <i class="fas fa-angle-right"></i></router-link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

   <div class="modal fade" id="importSwagger" tabindex="-1">
      <div class="modal-dialog">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title" id="exampleModalLabel">Import swagger</h5>
               <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeHostModal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <input type="text" class="form-control mb-3" v-model="swaggerUrl" placeholder="https://example.com/swagger.json">
               <button type="button" class="btn btn-success" v-on:click="importSwagger()">Import</button>
            </div>
         </div>
      </div>
   </div>

   <div class="modal fade" id="AddPageManually" tabindex="-1">
      <div class="modal-dialog modal-xl">
         <div class="modal-content">
            <div class="modal-header">
               <h5 class="modal-title" id="exampleModalLabel">{{ title }} page</h5>
               <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeManualPage" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <manualPageForm :page_id="page_id" :key="refresh" v-on:callback="formCallback" />
            </div>
         </div>
      </div>
   </div>

   </div>
</template>
<script>
  import manualPageForm from './pageForm.vue'
  import Authentication from './authentication.vue'
  export default {
    components: {
      manualPageForm,
      Authentication
    },
    data () {
      return {
        pages: [],
        active: 0,
        project_id : this.$route.params.prod_id,
        org_id : this.$route.params.org_id,
        swaggerUrl : '',
        page_id: 0,
        refresh: Math.random(),
        title: '',
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      deletePage(id) {
        if (confirm("Are you sure you want to delete?")) {
          const me = this;
          this.$axios.delete(this.$server + 'organisation/' + me.$route.params.org_id + '/project/' + me.$route.params.prod_id + "/pages/" + id)
          .then(res => {
            var r = res.data;
            if (r.success) {
                me.init();
                me.$swal({
                    title: r.message
                });
            }
          });
        }
      },
      init() {
        const me = this;
        this.$axios.get(this.$server + 'organisation/' + me.$route.params.org_id + '/project/' + me.$route.params.prod_id + "/pages?s=")
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.pages = r.data;
          }
        });
      },
      importSwagger() {
        const me = this;
        this.$axios.post(this.$server + 'organisation/' + me.$route.params.org_id + '/project/' + me.$route.params.prod_id + "/pages/swagger", {
            url: me.swaggerUrl
          })
        .then(res => {
          var r = res.data;
          if (r.success) {
              this.$swal({
                  title: r.message
              });
              me.init();
          }
        });
      },
      autoScan() {
        const me = this;
        this.$axios.get(this.$server + 'organisation/' + me.$route.params.org_id + '/projects/' + me.$route.params.prod_id + "/scan/page")
        .then(res => {
          var r = res.data;
          if (r.success) {
              me.$swal({
                  title: r.message
              });
              me.init();
          }
        });
      },
      setActive(host_id) {
        const me = this;
        this.$axios.post(this.$server + 'organisation/' + me.$route.params.org_id + '/projects/' + me.$route.params.prod_id + '/host/active', {
            host_id : host_id
          })
        .then(res => {
          var r = res.data;
          if (r.success) {
            me.$swal({
                title: r.message
            });
            me.init();
          }
        });
      },
      EditPage(page_id) {
        this.page_id = page_id;
        this.refresh = Math.random();
      },

      formCallback(r) {
        if (r == true) {
          this.init();
          document.getElementById("closeManualPage").click();
        }
        this.title = r;
      }
    }
  }
</script>